import { format } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

export const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function toDateFromLocaleStringDate(v: string | Date): Date {
  return utcToZonedTime(v, tz);
}

export function toLocaleDateTimeDBString(v: Date | null | undefined): string {
  if (!v || isNaN(v.getTime())) {
    return ''; // or return a default date string
  }
  return format(zonedTimeToUtc(v, tz), `yyyy-MM-dd HH:mm:ss.SSSSSS`);
}
